import { Link } from "react-router-dom";
import { Box, Button } from "@mui/material";

const Error = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box textAlign="center">
        <Box mb={1}>
          <h3>Oops! Page not found</h3>
        </Box>
        <p>We can't seem to find the page you're looking for.</p>
        <Box mt={2}>
          <Link to="/">
            <Button>back home</Button>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default Error;
